import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { THINGS } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'parent',
    label: 'Parent',
    value: ({ value }) => value?.name,
    content: ({ entry, value }) => (
      value && (
        <Link to={`/things/${entry.parent.id}`}>
          <Text>{value}</Text>
        </Link>
      )
    ),
  },
  {
    key: 'emoji',
    label: 'Emoji',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/things/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const Things = () => {
  const { data } = useQuery(THINGS, { fetchPolicy: 'network-only' } );

  return (
    <View>
      <Title>Things</Title>

      <Link to="/things/new">
        <Text>Add Thing</Text>
      </Link>

      {data && (
        <DataTable.Simple
          data={data.things}
          columns={columns}
        />
      )}
    </View>
  );
};

export default Things;
